import { render, staticRenderFns } from "./other_llp_details.vue?vue&type=template&id=360dc6fb&"
import script from "./other_llp_details.vue?vue&type=script&lang=js&"
export * from "./other_llp_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports